import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ServiceTypeService extends BaseService {

  PATH_OF_API = environment.BaseApiUrl;

  constructor(public httpClient: HttpClient, authService: AuthService) {
    super(authService);
  }
  public getServiceTypeList(token: string): Observable<any> {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    return this.httpClient.get<any>(this.PATH_OF_API + '/PaymentServiceType/list', { headers: headers });
  }

}
